import React from 'react'

export default function MenuPage() {
    const handleDownload = () => {
        const link = document.createElement("a");
        link.href = "/menu.pdf"; // make sure this file exists in your public folder
        link.download = "V The Grand Shoba Menu.pdf";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
  return (
    <>
      <div className="menu-img">
        <img src="/images/menuimg_.jpg" loading="lazy"   alt="menu img" />
      </div>
    <div className="container">
       <div className="container-fluid">
         
       <div className="row m-auto">
            <div className="col-md-12">
               <div className="menu-title mt-4">
                <h3>Menu</h3>
               </div>
               <div className="menu-table">
                <div className="menu-table-title pb-2">
                    <h4><span>V The Grand Shoba </span>Nasta Pani</h4>
                </div>
                <ul className="list-group">
                  {/* <li className="list-group-item">Assorted Indian Breads <span className='float-end text-success'  >&#8377; 150/p</span></li> */}
                  <li className="list-group-item">Assorted Indian Breads </li>
                  <li className="list-group-item">Tawa Butter Roti </li>
                  <li className="list-group-item">Tandoori Roti</li>
                  <li className="list-group-item">Butter Tandoori Roti</li>
                  <li className="list-group-item">Missi Roti </li>
                  <li className="list-group-item">Butter Naah </li>
                  <li className="list-group-item">Garlic Naan </li>
                  <li className="list-group-item">Cheese Naan </li>
                  <li className="list-group-item">Lacha Paratha </li>
                  <li className="list-group-item">Pudina Paratha </li>
                  <li className="list-group-item">Stuffed Kulcha</li>
                </ul>
               </div>

               <div className="menu-table mt-5">
                <div className="menu-table-title pb-2">
                    <h4><span>V The Grand Shoba </span>Rice Delicacies</h4>
                </div>
                <ul className="list-group">
                  <li className="list-group-item">Plain Rice </li>
                  <li className="list-group-item">Jeera Rice </li>
                  <li className="list-group-item">Curd Rice </li>
                  <li className="list-group-item">Veg Pulao </li>
                  <li className="list-group-item">Matar Pulao </li>
                  <li className="list-group-item">Comfort Bowl – Dal Khichdi </li>
                  <li className="list-group-item">Subz Biryani</li>
                  
                </ul>
               </div>
            </div>
          
          <div className="menu-btn ">
            <button onClick={handleDownload}>View Full Menu</button>
          </div>


        </div>
       </div>
    </div>
    </>
  )
}
